import { render, staticRenderFns } from "./Dunes.vue?vue&type=template&id=a6338b62&scoped=true&"
import script from "./Dunes.vue?vue&type=script&lang=js&"
export * from "./Dunes.vue?vue&type=script&lang=js&"
import style0 from "./Dunes.vue?vue&type=style&index=0&id=a6338b62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6338b62",
  null
  
)

export default component.exports